var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7 24c0-9.389 7.611-17 17-17s17 7.611 17 17-7.611 17-17 17S7 33.389 7 24M24 5C13.507 5 5 13.507 5 24s8.507 19 19 19 19-8.507 19-19S34.493 5 24 5m8.707 13.707a1 1 0 0 0-1.414-1.414L22 26.586l-5.293-5.293a1 1 0 0 0-1.414 1.414l6 6 .707.707.707-.707z",
  clipRule: "evenodd"
})));
export default SvgCheckCircle;